/**
 * Action buttons for SmswiserCampaignStatsTab (Copy as draft, Scale)
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { Button } from '@/components/ui';

interface SmswiserCampaignStatsTabActionsProps {
  selectedCount: number;
  isLoading: boolean;
  isPending: boolean;
  onCopyAsDraft: () => void;
  onScale: () => void;
}

export const SmswiserCampaignStatsTabActions: FC<SmswiserCampaignStatsTabActionsProps> = ({
  selectedCount,
  isLoading,
  isPending,
  onCopyAsDraft,
  onScale,
}) => {
  if (selectedCount === 0) return undefined;

  const label = selectedCount > 1 ? ` (${selectedCount})` : '';
  const disabled = isPending || isLoading;

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="gap-2"
        disabled={disabled}
        onClick={onCopyAsDraft}
      >
        Copy as draft{label}
      </Button>
      <Button
        variant="default"
        size="sm"
        className="gap-2"
        disabled={disabled}
        onClick={onScale}
      >
        Scale drop{label}
      </Button>
    </>
  );
};
